/**
 * Stark Product Pricing API Integration
 * Handles price calculations via Prestige Mills API
 * Used by stark-product-config.liquid for dynamic pricing
 */

function getPriceFromStark({
  SKU,
  isPristine,
  isPadding,
  widthInches,
  LengthInches,
  BindingMethod,
}) {
  var payload = JSON.stringify({
    SKU: SKU,
    BindingMethod: BindingMethod,
    WidthInInches: widthInches,
    LengthInInches: LengthInches,
    IsPristineTreatment: isPristine,
    IsAddingPadding: isPadding,
  });

  var requestOptions = {
    method: "POST",
    body: payload,
    redirect: "follow",
    headers: {
      "Content-Type": "application/json",
    },
  };

  const apiUrl = "https://pmapapi.prestigemills.com/ViewItem/RugCalculation";

  return fetch(apiUrl, requestOptions)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .then((data) => {
      const template = window.TEMPLATE_SUFFIX || "stark";
      const chargeType = template === "stark-designer-products" ? "TradeCharge" : "RetailCharge";

      const totalCarpetCharge =
        data.CalculationCharge?.[chargeType]?.TotalCharge || 0;

      const calcValues =
        data.CalculationCharge?.[chargeType]?.CalculationValues || [];

      const paddingTotal =
        calcValues.find((item) => item.Type === "Padding")?.Total || 0;

      const pristineTotal =
        calcValues.find((item) => item.Type === "Pristine")?.Total || 0;

      return {
        ok: true,
        totalCarpetCharge: totalCarpetCharge,
        totalPadding: paddingTotal,
        totalPristine: pristineTotal,
      };

    })
    .catch((error) => {
      return {
        ok: false,
        error: error.message,
      };
    });
}

const PriceStore = {
  cache: {},

  async fetchGroupedPrices(SKU, widthInches, LengthInches, BindingMethod, template) {
    const cacheKey = `${SKU}-${widthInches}x${LengthInches}-${template || 'default'}`;

    if (this.cache[cacheKey]) {
      return this.cache[cacheKey];
    }

    const requestParams = [
      { isPadding: false, isPristine: false },
      { isPadding: true, isPristine: false },
      { isPadding: false, isPristine: true },
      { isPadding: true, isPristine: true },
    ];

    const requests = requestParams.map(({ isPadding, isPristine }) => {
      const key = generatePriceKey(isPristine, isPadding);

      return getPriceFromStark({
        SKU,
        isPadding,
        isPristine,
        widthInches,
        LengthInches,
        BindingMethod,
        template,
      }).then((result) => {
        return { key, result };
      });
    });

    const results = await Promise.all(requests);

    this.cache[cacheKey] = results.reduce((acc, { key, result }) => {
      acc[key] = result;
      return acc;
    }, {});

    return this.cache[cacheKey];
  },

  async getPrice(SKU, widthInches, LengthInches, isPristine, isPadding, template) {
    const cacheKey = `${SKU}-${widthInches}x${LengthInches}-${template || 'default'}`;
    const priceKey = generatePriceKey(isPristine, isPadding);

    if (!this.cache[cacheKey]) {
      await this.fetchGroupedPrices(SKU, widthInches, LengthInches, "Serging", template);
    }

    const result = this.cache[cacheKey][priceKey];

    return result;
  },

  clearCache() {
    this.cache = {};
  }
};

function generatePriceKey(isPristine, isPadding) {
  let key;
  if (isPristine && isPadding) {
    key = "priceWithBoth";
  } else if (isPristine) {
    key = "priceWithPristine";
  } else if (isPadding) {
    key = "priceWithPadding";
  } else {
    key = "price";
  }

  return key;
}
